import React, { useState } from 'react';
import { useField } from 'react-final-form';

import { EditOutlined } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useCurrentScenarioName } from '@wp-block-builder/editor/hooks';

import { useScenariosMutator } from '../../../hooks';

import ScenarioDialog from './ScenarioDialog';

function Button({ name }: { name: string }) {
  const [, setCurrentScenarioName] = useCurrentScenarioName();
  const [open, setOpen] = useState(false);
  const { input } = useField<{ name: string }>(name);
  const { value, onChange } = input;
  const scenarios = useScenariosMutator();

  const renderDialog = () => {
    if (!open) {
      return null;
    }
    return (
      <ScenarioDialog
        title="Edit data scenario"
        description="Update the name of your scenario."
        confirmButtonLabel="Edit"
        handleClose={() => setOpen(false)}
        initialValue={value.name}
        open={open}
        onSubmit={(name: string) => {
          onChange({ ...value, name });
        }}
        onDelete={() => {
          const index = scenarios.value.map(({ name }) => name).indexOf(name);
          scenarios.remove(index);
          setCurrentScenarioName(null);
        }}
      />
    );
  };
  return (
    <>
      <IconButton size="small" onClick={() => setOpen(true)} sx={{ p: 0.25 }}>
        <EditOutlined sx={{ color: 'grey.600' }} fontSize="small" />
      </IconButton>
      {renderDialog()}
    </>
  );
}

export default function EditCurrentScenarioButton() {
  const [name] = useCurrentScenarioName();

  if (!name) {
    return null;
  }
  return <Button name={name} />;
}
